import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { useShellTheme } from '@frontend/shell-theme';
import { NakedButton } from '@frontend/design-system';

export const PendoTrigger = () => {
  const { colorObject } = useShellTheme('colorObject');
  return (
    <NakedButton
      id='pendo-trigger'
      css={css`
        position: relative;
        align-items: center;
        background: ${colorObject.helpColor};
        display: flex;
        height: 3em;
        justify-content: center;
        transition: background 0.3s ease-in-out;
        width: var(--nav-icon-width);
        :hover {
          background: ${colorObject.hover};
        }
      `}
    >
      <Icon
        name='help'
        css={css`
          color: ${colorObject.iconColor};
        `}
      />
    </NakedButton>
  );
};
